import { apiEnv } from '@mgmresorts/wcl-utils';
import React from 'react';

export interface EscKeyListenContextValue {
  subscribe: (listener: () => void) => {
    unsubscribe: () => void;
  };
}

export const EscKeyListenContext = React.createContext<EscKeyListenContextValue>({
  subscribe() {
    if (apiEnv === 'test') {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      return { unsubscribe() {} };
    }

    throw new TypeError(`EscKeyListenContext isn't initialized`);
  },
});
